module.exports = __webpack_public_path__ + "img/united-kingdom.e6679990.png";